const PREFIX = 'PAYMENT_METHOD'

export const SET_PAYMENT_METHODS = `${PREFIX}.SET_PAYMENT_METHODS`
export const SET_QRIS_PAYMENT_METHODS = `${PREFIX}.SET_QRIS_PAYMENT_METHODS`
